import React from 'react'
import Modal from 'react-modal'

import ga from '../../../common/utils/ga'
import AddItemToCollectionContainer from './collection/collectionLoadableContainer'
import AddItemToCartContainer from './cart/cartLoadableContainer'
import SignInContainer from './user/signInLoadableContainer'
import SignUpContainer from './signup/signUpLoadableContainer'
import GetFeedbackContainer from './user/getFeedbackLoadableContainer'

export default ({
  isModalOpen,
  closeModal,
  openModal,
  openModalType,
  openModalData
}) => {
  function closeModalWithAnalytics(eventCategory, eventLabel) {
    return () => {
      ga('send', {
        hitType: 'event',
        eventCategory: `${eventCategory};close`,
        eventAction: 'click',
        eventLabel
      })

      closeModal()
    }
  }

  const renderModalContent = () => {
    switch (openModalType) {
      case 'addItemToCollection':
        return (
          <AddItemToCollectionContainer
            openModalData={openModalData}
            closeModal={closeModal}
          />
        )

      case 'addItemToCart':
        return <AddItemToCartContainer openModalData={openModalData} />

      case 'signIn':
        return (
          <SignInContainer
            openModal={openModal}
            closeModal={closeModal}
            openModalData={openModalData}
          />
        )

      case 'signUp':
        return <SignUpContainer closeModal={closeModal} />

      case 'getFeedback':
        return (
          <GetFeedbackContainer
            closeModal={closeModalWithAnalytics('csatmodal', 'x')}
            openModalData={openModalData}
          />
        )

      default:
        return null
    }
  }

  const onRequestCloseFn =
    openModalType === 'getFeedback'
      ? closeModalWithAnalytics('csatmodal', 'outofmodal')
      : closeModal

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={onRequestCloseFn}
      contentLabel="Modal"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      {renderModalContent()}
    </Modal>
  )
}
